<template>
  <div class="card card-custom gutter-b overflow-hidden" :class="classes">
    <transition name="fade">
      <div v-if="loading" class="card-loading">
        <div class="animation-loading"></div>
        <h1>
          <b-spinner
            variant="primary"
            style="width: 2rem; height: 2rem;"
          ></b-spinner>
          <b style="color:#3699ff"> Cargando datos... </b>
        </h1>
        <!-- <b-spinner variant="primary" style="width: 1rem; height: 1rem;" label="Large Spinner"></b-spinner> -->
      </div>
    </transition>
    <div class="card-header" :class="headClass" v-if="hasTitleSlot || title">
      <div class="card-title-container">
        <div class="card-title">
          <slot name="title" v-if="hasTitleSlot"></slot>
          <h3 class="card-label" v-if="!hasTitleSlot">{{ title }}</h3>
        </div>
        <div class="card-subtitle">
          <slot name="subtitle" v-if="hasSubtitleSlot"></slot>
          <span class="card-label" v-if="!hasSubtitleSlot">{{ subtitle }}</span>
        </div>
      </div>
      <div class="card-toolbar">
        <slot name="toolbar"></slot>
      </div>
    </div>
    <div>
      <slot name="subheader"></slot>
    </div>
    <div
      class="card-body"
      v-bind:class="{
        bodyClass,
        'body-fit': bodyFit,
        'body-fluid': bodyFluid
      }"
    >
      <slot name="body"></slot>
    </div>
    <div class="card-footer" v-if="hasFootSlot">
      <slot name="foot"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "KTCard",
  props: {
    /**
     * String title
     */
    title: String,
    /**
     * String sub title
     */
    subtitle: String,
    /**
     * String sub title
     */
    subheader: String,
    /**
     * Set card head size. Eg. md, lg, sm, etc.
     */
    headSize: String,
    /**
     * Set card to fluid
     */
    fluidHeight: Boolean,
    /**
     * Set card to fluid in half
     */
    fluidHalfHeight: Boolean,
    /**
     * Set overlay head
     */
    headOverlay: Boolean,
    /**
     * Set extra class for main card
     */
    cardClass: String,
    /**
     * Set extra class for card head
     */
    headClass: String,
    /**
     * Set extra class for card body
     */
    bodyClass: String,
    /**
     * Set card body to fit
     */
    bodyFit: Boolean,
    /**
     * Set card body to fluid
     */
    bodyFluid: Boolean,
    /**
     * Loading state
     */
    loading: {
      type: Boolean,
      default: false
    },
    /**
     * Code examples
     */
    example: Boolean
  },
  components: {},
  methods: {},
  computed: {
    classes() {
      const cls = {
        "example example-compact": this.example,
        "height-fluid": this.fluidHeight,
        "height-fluid-half": this.fluidHalfHeight,
        "head-overlay": this.headOverlay
      };

      cls[this.headSizeClass] = this.headSizeClass;

      // append extra classes
      if (this.cardClass) {
        cls[this.cardClass] = true;
      }

      return cls;
    },
    hasTitleSlot() {
      return !!this.$slots["title"];
    },
    hasSubtitleSlot() {
      return !!this.$slots["subtitle"];
    },
    hasFootSlot() {
      return !!this.$slots["foot"];
    },
    headSizeClass() {
      if (this.headSize) {
        return `head-${this.headSize}`;
      }
      return false;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.animation-loading {
  position: absolute;
  top: 0;
  left: 0;
  width: 10%;
  height: 100%;
  background: linear-gradient(rgba(#0083ca, 0.4), #0083ca, rgba(#0083ca, 0.4));
  opacity: 0.3;
  z-index: 1;
  animation: anim-loading 3s infinite linear;
  transform: translateX(-50%);
}

@keyframes anim-loading {
  0% {
    width: 0%;
    left: 0;
    opacity: 0;
  }

  50% {
    width: 10%;
    opacity: 0.7;
  }

  100% {
    width: 0%;
    left: 100%;
    opacity: 0;
  }
}
</style>
